import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  CloudinaryImage,
  type CloudinaryTransformConfig,
  theme,
  useResponsive,
} from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

const ProductDetailsBannerSmall = (props: Props) => (
  <View style={styles.containerXS}>
    <CloudinaryImage
      baseUrl={props.productImageUrl}
      config={IMAGE_TRANSFORM_CONFIG}
      contentFit="contain"
      aria-label={props.productName}
      style={styles.imageSmall}
    />
  </View>
);

// ─────────────────────────────────────────────────────────────────────────────

const ProductDetailsBannerLarge = (props: Props) => {
  const { match } = useResponsive();

  const responsiveStyle = match([
    styles.imageLargeXS,
    styles.imageLargeSM,
    styles.imageLargeMD,
    styles.imageLargeLG,
  ]);

  const imageStyles = [styles.imageLarge, responsiveStyle];

  return (
    <View style={styles.containerSM}>
      <CloudinaryImage
        baseUrl={props.productImageUrl}
        config={IMAGE_TRANSFORM_CONFIG}
        contentFit="contain"
        aria-label={props.productName}
        style={imageStyles}
      />
    </View>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsBanner = {
  Small: ProductDetailsBannerSmall,
  Large: ProductDetailsBannerLarge,
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_TRANSFORM_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.65, width: 0.4 },
  { width: 500 },
];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    marginRight: -50,
  },
  containerSM: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing['8'],
  },
  imageSmall: {
    width: 132,
    height: 132,
  },
  imageLarge: {
    flexShrink: 1,
  },
  imageLargeXS: {
    width: 300,
    height: 300,
  },
  imageLargeSM: {
    width: 340,
    height: 340,
  },
  imageLargeMD: {
    width: 480,
    height: 480,
  },
  imageLargeLG: {
    width: 580,
    height: 580,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  productName: string;
  productImageUrl: string;
};
